import React from 'react';
import Content from '../../content';
import Column from '../../column/index';
import Usps from './usps';
import Title from './title';

const USPs = ({
  columnWidth,
  align,
  justify,
  card,
  order,
  title,
  variant,
  offset,
}) => (
  <Column
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    card={card}
    order={order}
    offset={offset}
  >
    <Content>
      {title && <Title>{title}</Title>}
      <Usps
        variant={variant}
      />
    </Content>
  </Column>
);

export default USPs;
